import React from 'react'
import 'whatwg-fetch'

class Company extends React.Component {
    render() {
        return (
            <div style={{ marginTop: '120px', textAlign: 'center', color: '#fff' }}>
                <title>nomo studios, llc</title>
                <h1>nomo studios, llc</h1>
                <br />
                <p>An app development studio based out of USA</p>
                <p>For inquiries, please mail <a href='mailto:support@mrjotto.com'>support@mrjotto.com</a></p>
                <br />
                <p>Copyright &copy; 2018 nomo studios, llc. All rights reserved.</p>
            </div>
        )
    }
}

export default Company



/** WEBPACK FOOTER **
 ** ./src/containers/Company/company.js
 **/